import ReportService from "../../../services/ReportService";
class AlarmDatewiseFilter {
  momentToFormat = (m) => m.format("YYYY-MM-DD");

  async getAlarmDatewiseReport(selectedDate, userGroup) {
    try {
      const response = await ReportService.getAlarmDatewiseReport(
        this.momentToFormat(selectedDate),
        userGroup
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}
const alarmDatewiseFilter = new AlarmDatewiseFilter();
export default alarmDatewiseFilter;
